<template>
  <div v-if="id" class="stat-grid">
    <inquiries
      :id="id"
      :status="['pending', 'watching', 'ongoing', 'on_hold']"
    />

    <inquiries :id="id" :status="['success']" />

    <clients :id="id" />

    <properties :id="id" />

    <searches :id="id" />
  </div>
</template>

<script>
import Properties from "./analytics/Properties";
import Inquiries from "./analytics/Inquiries";
import Searches from "./analytics/Searches";
import Clients from "./analytics/Clients";

export default {
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },

  components: { Properties, Inquiries, Searches, Clients }
};
</script>

<style scoped>
.stat-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

/* Even widths at every size: 3-up → 2-up → 1-up. */
@media (max-width: 1280px) {
  .stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .stat-grid {
    grid-template-columns: 1fr;
  }
}
</style>
